import React, { useEffect, useState, useRef } from 'react';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import useWindowSize from '../../../hooks/useWindowSize';

import queryString from 'query-string';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import BobLoadingMask from '../../../components/BobLoadingMask';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import HealthInfoModal from '../Modals/HealthInfoModal';

import * as bobActions from '../../../actions/bobActions';
import * as ConfigurationActions from '../../../actions/configurationActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as ruleAction from '../../../actions/ruleActions';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

import classes from './RulesPanel.module.css';
import { isEmpty } from 'lodash';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const RulesPanel = ({
    bobLoading,
    companyInfo,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    entityRules,
    fetchEntityRulesAndScores,
    fetchEntitySensorData,
    fetchEntityRules,
    fetchSensorIds,
    fetchRuleDatails,
    history,
    isActive,
    refreshTab,
    setIsFromRulesGrid,
    setRefreshTab,
    setSelectedRule,
    setSelectedRuleSensors,
    setSelectedSensors,
    targetNavEquipment,
    ...props
}) => {
    const [sort, setSort] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [openRuleInfoModal, setOpenRuleInfoModal] = useState(false);
    const [moreDetails, setMoreDetails] = useState({});
    const [ruleNameColumnWidth, setRuleNameColumnWidth] = useState(350);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setRuleNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'ruleName', 350, true));
    }, [windowSize]);

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setRuleNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'ruleName', 350, true));

        const loadRules = async () => {
            const queryValues = queryString.parse(history.location.search);
            await fetchEntityRules(queryValues.company, queryValues.system, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format());
        };
        if (isEmpty(entityRules)) loadRules();
    }, []);

    useEffect(() => {
        const refresh = async () => {
            let sortName;

            if (sort[0]) {
                switch (sort[0].field) {
                    case 'ruleName':
                        sortName = sort[0].field.toLowerCase() + '^' + sort[0].dir;
                        break;
                    case 'priority':
                        sortName = sort[0].field.toLowerCase() + '^' + sort[0].dir;
                        break;
                    case 'currentStatus':
                        sortName = sort[0].field.toLowerCase() + '^' + sort[0].dir;
                        break;
                    default:
                        break;
                }
            }

            const queryValues = queryString.parse(history.location.search);

            if (!isEmpty(sort)) {
                await fetchEntityRules(queryValues.company, queryValues.system, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), { sort: sortName });
            } else {
                await fetchEntityRules(queryValues.company, queryValues.system, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format());
            }
            setRefreshTab('');
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const handlePageChange = event => {
        setSkip(event.page.skip);
        setTake(event.page.take);
    };
    
    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.dataItem[props.field] === 'Medium') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.dataItem[props.field] === 'High') {
            imgPath = '/assets/images/high.svg';
        }

        return (
            <td>
                <img className={classes.IconImage} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const statusCell = props => {
        let imgPath = '/assets/images/okIconColor.svg';
        if (props.dataItem[props.field] === 'InFault') {
            imgPath = '/assets/images/inFaultIconColor.svg';
        } else if (props.dataItem[props.field] === 'Failure') {
            imgPath = '/assets/images/failedIconColor.svg';
        }
    
        return (
            <td>
                <img className={classes.IconImage} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const isCustomCell = props => {
        return (
            <td>
                {props.dataItem[props.field] ? 'Custom' : 'K2A'}
            </td>
        );
    };

    const enableOrDisableCell = props => {
        let imgPath = '/assets/images/disableIconColor.svg';
        if (props.dataItem[props.field]) {
            imgPath = '/assets/images/enableIconColor.svg';
        }
    
        return (
            <td>
                <img className={classes.IconImage} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const handleSort = async event => {
        setSort(event.sort);
        let sort;

        if (event.sort[0]) {
            switch (event.sort[0].field) {
                case 'ruleName':
                    sort = event.sort[0].field.toLowerCase() + '^' + event.sort[0].dir;
                    break;
                case 'priority':
                    sort = event.sort[0].field.toLowerCase() + '^' + event.sort[0].dir;
                    break;
                case 'currentStatus':
                    sort = event.sort[0].field.toLowerCase() + '^' + event.sort[0].dir;
                    break;
                default:
                    break;
            }
        }

        const queryValues = queryString.parse(history.location.search);

        if (sort) {
            await fetchEntityRules(queryValues.company, queryValues.system, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), { sort });
        } else {
            await fetchEntityRules(queryValues.company, queryValues.system, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format());
        }
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type={'OpenRuleInfoModalFromSystemRulesPage'}
                    ruleData={props.dataItem}
                    setSelectedRule={(ruleData) => getRuleDetails(ruleData)}
                />
            </td>
        );
    };

    const getRuleDetails = async (rule) => {
        let details = await fetchRuleDatails(rule.ruleId);
        details.currentStatus = rule.currentStatus;
        setMoreDetails(details);
        setOpenRuleInfoModal(true);
    };

    const handleCloseRuleInfoModal = () => {
        setOpenRuleInfoModal(false);
        setMoreDetails({});
    };

    const handleNameNavigation = dataItem => {
        const queryValues = queryString.parse(history.location.search);
        queryValues.childId = '383849dd-bd20-4ee2-a0e5-1b192ddc4f81';
        queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb02';

        const queryValuesString = queryString.stringify(queryValues);

        return `system?${queryValuesString}`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/system';

        const queryValues = queryString.parse(history.location.search);
        queryValues.childId = '383849dd-bd20-4ee2-a0e5-1b192ddc4f81';
        queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb02';

        setIsFromRulesGrid(true);
        setSelectedRule(dataItem);

        const rule = [dataItem.ruleId];
        let entityId = queryValues.system;
        

        const ids = await fetchSensorIds(queryValues.site, entityId, rule);
            
        const sensors = ids.filter(s => s.id !== EMPTY_GUID);
        
        setSelectedRuleSensors(sensors);
        setSelectedSensors(sensors);

        if (!isEmpty(sensors)) {
            fetchEntitySensorData(sensors, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes: [], entityId });
        }

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <Link
                    to={handleNameNavigation(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    if (!isActive) return null;

    return (
        <div className={classes.RulesPanel}>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable
                    sort={sort}
                    onSortChange={(e) => {
                        handleSort(e);
                    }}
                    className={classes.KendoGrid}
                    data={entityRules.slice(skip, take + skip)}
                    take={take}
                    skip={skip}
                    total={entityRules.length}
                    onPageChange={handlePageChange}
                    pageable={pageable}
                    reorderable
                >
                    {
                        bobLoading.includes('EntityRules') ?
                            <GridNoRecords>
                                Loading rules
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column
                        field="ruleName"
                        title={dashboardContent.rule}
                        cell={nameCell}
                        width={ruleNameColumnWidth}
                    />
                    <Column
                        field="isCustom"
                        title={dashboardContent.k2aOrCustom}
                        width="250px"
                        cell={isCustomCell}
                    />
                    <Column field="issueTypes" title={dashboardContent.issueTypes} width="350px" />
                    <Column
                        field="isEnabled"
                        title={dashboardContent.enableOrDisable}
                        width="200px"
                        cell={enableOrDisableCell}
                    />
                    <Column
                        field="priority"
                        title={dashboardContent.priority}
                        width="225px"
                        cell={priorityCell}
                    />
                    <Column
                        field="currentStatus"
                        title={dashboardContent.status}
                        width="225px"
                        cell={statusCell}
                    />
                    <Column
                        field=""
                        title=""
                        width="80px"
                        locked={true}
                        sortable={false}
                        filterable={false}
                        cell={actionsCell}
                    />
                </Grid>
            </div>
            {
                openRuleInfoModal ?
                    <HealthInfoModal
                        type={'RuleInfoModal'}
                        ruleDetails={moreDetails}
                        onCloseModal={() => { handleCloseRuleInfoModal(); }}
                    />
                    :
                    null
            }
            {
                bobLoading.includes('EntityRules') || bobLoading.includes('fetchRuleInfo') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading:              state.bob.bobLoading,
        companyInfo:             state.companyInfo,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        desiredInterval:         state.dashboard.desiredInterval,
        entityRules:             state.bob.entityRules
    };
};

const mapDispatchToProps = {
    ...bobActions,
    ...ConfigurationActions,
    ...DashboardActions,
    ...ruleAction
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RulesPanel));
